import axios from 'axios';

const model = 'Dificultad';
const API_URL = process.env.VUE_APP_API_URL;

export default {
  listar(params = {}) {
    const query = new URLSearchParams();
    if (params.glosa != null && params.glosa !== '') query.append('glosa', params.glosa);
    if (typeof params.vigente === 'boolean') query.append('vigente', String(params.vigente));
    const qs = query.toString();
    return axios.get(`${API_URL}/${model}/v1/list${qs ? `?${qs}` : ''}`);
  },
};
